import React from "react";

/**
 * FushaFeedback — the private coaching panel shown to the AUTHOR only,
 * inline under the composer (never a toast, never a separate screen —
 * privacy by visual containment inside the composer's Surface).
 *
 * Props:
 *   feedback         — { verdict, issues: [{kind, text, suggestion, note_en, note_ar}], summary_en }
 *   onApplySuggestion — (issueText, suggestion) => void — string-replace in the draft
 */
export default function FushaFeedback({ feedback, onApplySuggestion }) {
  if (!feedback) return null;
  const { verdict, issues = [] } = feedback;
  const summary = feedback.summary_ar || feedback.summary_en;

  const heading =
    verdict === "unavailable"
      ? "المدقّقُ غيرُ متاحٍ الآن — مسودّتُك محفوظة، حاول بعد قليل."
      : verdict === "reject"
      ? "قريب! ليست فصحى بعدُ — إليك ما يلزم إصلاحُه:"
      : "نُشِرَ المنشور — وهذه ملاحظاتٌ خاصّةٌ لك:";

  return (
    <div
      className="rounded-xl px-4 py-3 mt-3 animate-rise"
      style={{
        background: "color-mix(in srgb, var(--tag-rose) 8%, transparent)",
        border: "1px solid var(--panel-line)",
      }}
      role="status"
    >
      <p className="text-sm font-medium mb-1" style={{ color: "var(--parchment)" }}>
        {heading}
      </p>
      {summary && verdict !== "unavailable" && (
        <p className="text-xs mb-2" style={{ color: "var(--parchment-dim)" }}>
          {summary}
        </p>
      )}
      <ul className="list-none p-0 m-0 space-y-2">
        {issues.map((issue, i) => (
          <li key={i} className="text-sm">
            <div className="flex items-center gap-2 flex-wrap" dir="rtl">
              {issue.text && (
                <span className="font-arabic text-base" style={{ color: "var(--tag-rose)" }}>
                  {issue.text}
                </span>
              )}
              {issue.suggestion && (
                <>
                  <span style={{ color: "var(--parchment-dim)" }}>←</span>
                  <span className="font-arabic text-base" style={{ color: "var(--gold)" }}>
                    {issue.suggestion}
                  </span>
                </>
              )}
            </div>
            {(issue.note_ar || issue.note_en) && (
              <p className="text-xs mt-0.5" style={{ color: "var(--parchment-dim)" }}>
                {issue.note_ar || issue.note_en}
              </p>
            )}
            {issue.text && issue.suggestion && onApplySuggestion && (
              <button
                onClick={() => onApplySuggestion(issue.text, issue.suggestion)}
                className="dt-ghost-btn text-xs px-2 py-1 rounded-lg mt-1"
              >
                استبدل
              </button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
